import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig } from '../shared/app.config';
import { DOCUMENT } from '@angular/common';

const magnoliaUrls = {
  headerFooter: '/header_footer',
  help: '/help/main/page',
  login: '/login/main/page'
};

@Injectable({
  providedIn: 'root'
})
export class MagnoliaService {
  private readonly cmsHttp: HttpClient;

  constructor(@Inject(DOCUMENT) private readonly doc: Document, httpBackend: HttpBackend, private readonly config: AppConfig) {
    this.cmsHttp = new HttpClient(httpBackend);
  }

  getMagnoliaContent(page: keyof typeof magnoliaUrls) {
    const baseUrl = this.doc.location.pathname.split('/')[1];
    return this.cmsHttp.get(this.config.magnoliaUrl + (baseUrl || 'delta').toUpperCase() + magnoliaUrls[page], { responseType: 'text' });
  }

}
